// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment-fee-container {
    display: flex;
    flex-direction: column;
    margin: 16px 0;
  }
  
  .appointment-fee-container label {
    font-size: 0.95rem;
    font-weight: 500;
    margin-bottom: 6px;
    color: #2c3e50;
  }
  
  .appointment-fee-container input {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    max-width: 200px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AdminScheduling/SchedulingStyles/AppointmentFeeInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB","sourcesContent":[".appointment-fee-container {\n    display: flex;\n    flex-direction: column;\n    margin: 16px 0;\n  }\n  \n  .appointment-fee-container label {\n    font-size: 0.95rem;\n    font-weight: 500;\n    margin-bottom: 6px;\n    color: #2c3e50;\n  }\n  \n  .appointment-fee-container input {\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    font-size: 1rem;\n    max-width: 200px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
